import React from 'react'

import { Moment } from 'moment'

import { observer } from 'mobx-react'

import type Store from 'modules/attendance/components/ClockIn/Store'
import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'
import { SidePanelTab } from 'modules/attendance/lib/sidepanelTabTypes'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'

import BankOfHoursBreakdownPanel from './BankOfHoursBreakdownPanel'
import BreakdownPanel from './BreakdownPanel'
import CompensationPannel from './CompensationPannel'

type Props = {
  tabFromNavigation: SidePanelTab
  timeSheetDate: Moment
  employeeId: number
  store: Store
}

const TabsBreakdown = ({ tabFromNavigation, timeSheetDate, employeeId, store }: Props) => {
  const timesheetData = useTimesheetData()
  const { featureByName } = timesheetData
  const bankOfHoursEnabled = TimesheetFeatures.BANK_OF_HOURS in featureByName
  const compensationFlowV2Enabled = TimesheetFeatures.COMPENSATION_FLOW_V2 in featureByName

  const { featureAvailability: canSeeHourBalance } = useAttendanceFeatures('hour_balance_visibility')
  const { featureAvailability: hasHourBalanceUI } = useAttendanceFeatures('dev_hour_balance_ui')
  const showHourBalance = canSeeHourBalance && hasHourBalanceUI

  let safeTabFromNavigation: SidePanelTab = tabFromNavigation
  if (!showHourBalance && safeTabFromNavigation === 'compensation') {
    safeTabFromNavigation = 'worked_hours'
  }
  if (!showHourBalance && safeTabFromNavigation === 'balance') {
    safeTabFromNavigation = 'worked_hours'
  }

  if (compensationFlowV2Enabled && safeTabFromNavigation === 'compensation') {
    return (
      <CompensationPannel
        tabFromNavigation={safeTabFromNavigation}
        timeSheetData={timesheetData}
        timeSheetDate={timeSheetDate}
        employeeId={Number(employeeId)}
      />
    )
  } else if (bankOfHoursEnabled) {
    return (
      <BankOfHoursBreakdownPanel
        tabFromNavigation={safeTabFromNavigation}
        timeSheetData={timesheetData}
        timeSheetDate={timeSheetDate}
        employeeId={Number(employeeId)}
        store={store}
      />
    )
  } else {
    return (
      <BreakdownPanel
        tabFromNavigation={safeTabFromNavigation}
        timeSheetData={timesheetData}
        timeSheetDate={timeSheetDate}
        employeeId={Number(employeeId)}
        store={store}
      />
    )
  }
}

export default observer(TabsBreakdown)
